import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import type { ConnectionDetail } from './detailTypes'

export function ActivityRetentionBanner({
  row,
  onChoose,
}: {
  row: ConnectionDetail
  onChoose?: () => void
}) {
  if (row.status !== 'active' || row.activity_retention_years !== null) return null
  return (
    <Alert variant="warning">
      This Connection keeps all imported activity. Choose how long to keep it.
      {onChoose && (
        <>
          {' '}
          <Button variant="link" size="inline" onClick={onChoose}>
            Choose a period
          </Button>
        </>
      )}
    </Alert>
  )
}
